import { GetTheme, ThemeProvider } from "@arp/react-ndbx";
import React from "react";
import ScrollToTop from "./components/ScrollToTop";
import Router from "./routes";
//** Generic Error Modal */
import GenericErrorModal from "./components/pageLevel/genericErrorModal/GenericErrorModal";

import "../node_modules/@arp/react-ndbx/dist/index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { trackifyInit } from "@allianz/tracking";
import { TRACKIFY_EVENT } from "./config/const/enums";

import useInjectionDetection from "./hooks/useInjectionDetection";

//----------------------------------------------------------------

function App() {
	const defaultTheme = GetTheme();
	const queryClient = new QueryClient({});

	trackifyInit({
		appName: TRACKIFY_EVENT.TRACKIFY_APP_NAME,
		pageId: TRACKIFY_EVENT.TRACKIFY_PAGE_ID,
	});

	//** Check for unexpected script injected */
	useInjectionDetection();

	return (
		<ThemeProvider theme={defaultTheme}>
			<QueryClientProvider client={queryClient}>
				<ScrollToTop />
				<Router />
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
			<GenericErrorModal />
		</ThemeProvider>
	);
}

export default App;
